import { failureSaid } from "../localization/failure.ts";
import { say } from "../localization/say.ts";
import { act } from "../net/rally.ts";
import type { Candidate } from "./composer/mentions.ts";

export type Brought = { added: true } | { added: false; why: string };

export async function bringIn(conversation: string, who: Candidate): Promise<Brought> {
  try {
    await act("conversation.addParticipant", { conversation, account: who.account });
  } catch (cause) {
    return {
      added: false,
      why: failureSaid(cause, say("chat.broke")),
    };
  }

  try {
    await act("agent.share", { account: who.account, scope: "conversation", id: conversation });
  } catch {}
  return { added: true };
}
